import api from "../lib/axios";

export const parseTrackingNumber = async (imageFile: File, orderId: string) => {
  const formData = new FormData();
  formData.append("image", imageFile);
  formData.append("orderId", orderId);

  const { data } = await api.post("/status/parse-tracking-number", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });

  return data;
};

export const updateShippingStatus = async (
  orderId: string,
  trackingInfo: { trackingNumber: string; carrier: string },
  imageFile?: File | null,
) => {
  const formData = new FormData();
  formData.append(
    "data",
    JSON.stringify({
      orderId,
      trackingNumber: trackingInfo.trackingNumber,
      carrier: trackingInfo.carrier,
    }),
  );
  if (imageFile) {
    formData.append("image", imageFile);
  }
  const { data } = await api.put("/status/status", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return data;
};
